module.exports = {"id":"224599","name":"Yan Junling","rating":"73","photo":"./data/images/photos/1/224599.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YanJunling0.json
// module id = 4378
// module chunks = 0